import { IKnmAttachment } from 'APIPackage/KnmModule/interfaces/IKnmAttachment';
import { IKnmFormAttachment } from 'KnmPackage/MainModule/interfaces/IKnmFormAttachment';

export const convertSmevFormAttachmentToCreateData = (formAttachment: IKnmFormAttachment): IKnmAttachment | null => {
  const {
    guid,
    dateCreate,
    fileName,
    filePath,
    fileSize,
    mimeType,
    bucketName,
    correlationToken,
    hash,
    signed: isSigned,
    signatureInfo,
  } = formAttachment;

  if (!guid || !fileName || !filePath || typeof fileSize !== 'number' || !bucketName) {
    return null;
  }

  return {
    guid,
    dateCreate: dateCreate || null,
    fileName,
    filePath,
    fileSize,
    mimeType: mimeType || null,
    bucketName,
    correlationToken: correlationToken || null,
    hash: hash || null,
    signed: typeof isSigned === 'boolean' ? isSigned : null,
    signatureInfo: signatureInfo || null,
  };
};
